// eslint-disable-next-line
import Locale from "@/helper/locale/locale.js"

export function ErrorHandler() {
    this.onErrorCode = null;
    this.onError500 = null;
    this.onError400 = null;
    this.onError401 = null;
    this.onError404 = null;
    this.onError409 = null;
    this.onError412 = null;
    this.onError2091 = null;
    this.onError8000 = null;
    this.onError1204 = null;
    this.onErrorUser = null;
    this.onErrorDefault = null;

    this.title = '';
    this.alertModal = null;
    this.router = null;

    this.setAlertModal = function(alertModal) {
        this.alertModal = alertModal;
    };
    this.setTitle = function (title) {
        this.title = title;
    };
    this.setRouter = function (router) {
        this.router = router;
    };
    this.showAlert = function(msg) {
        if (this.alertModal != null) {
            this.alertModal
                .clearText()
                .setTitle(this.title)
                .setMsg(msg)
                .show();
        }
    };

    this.showAlertWithRelocate = function (msg) {
        if (this.alertModal != null) {
            this.alertModal
                .clearText()
                .setTitle(this.title)
                .setMsg(msg)
                .show();

            this.alertModal.onClickOk(() => {
                this.router.push('/register');
            });
        }
    };

    this.errorCase = function(err) {
        switch (err.id) {
            case 500:
                this.error500(err);
                break;
            case 400:
                this.error400(err);
                break;
            case 401:
                this.error401(err);
                break;
            case 404:
                this.error404(err);
                break;
            case 409:
                this.error409(err);
                break;
            case 412:
                this.error412(err);
                break;
            case 2091:
                this.error2091(err);
                break;
            case 8000:
                this.error8000(err);
                break;
            case 1905:
                this.errorUser(err);
                break;
            case 1204:
                this.error1204(err);
                break;
            default:
                this.errorDefault(err);
        }
    };

    this.errorCode = function(err) {
        console.log('error code:', err);
        if (typeof this.onErrorCode == 'function') {
            this.onErrorCode();
        }
    };

    this.error500 = function(err) {
        if (typeof this.onError500 == 'function') {
            this.onError500(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error400 = function(err) {
        if (typeof this.onError400 == 'function') {
            this.onError400(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error401 = function(err) {
        if (typeof this.onError401 == 'function') {
            this.onError401(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error404 = function(err) {
        if (typeof this.onError401 == 'function') {
            this.onError404(err);
        } else {
            this.showAlert(err.message);
        }
    }
    this.error409 = function(err) {
        if (typeof this.onError409 == 'function') {
            this.onError409(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error412 = function(err) {
        if (typeof this.onError412 == 'function') {
            this.onError412(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error2091 = function (err) {
        if (typeof this.onError2091 == 'function') {
            this.onError2091(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error8000 = function (err) {
        if (typeof this.onError8000 == 'function') {
            this.onError8000(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error1204 = function (err) {
        if (typeof this.onError1204 == 'function') {
            this.onError1204(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.errorUser = function(err) {
        if (typeof this.onErrorUser == 'function') {
            this.onErrorUser(err);
        } else {
            this.showAlertWithRelocate(Locale.getLbl().default.user_expire_error);
        }
    };
    this.errorDefault = function(err) {
        if (typeof this.onErrorDefault == 'function') {
            this.onErrorDefault(err);
        } else {
            this.showAlert(Locale.getLbl().default.connection_error);
        }
    };
}
